var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5459 10.4545C9.5459 9.96908 9.68985 9.49452 9.95956 9.09087C10.2293 8.68723 10.6126 8.37262 11.0611 8.18684C11.5096 8.00106 12.0032 7.95246 12.4793 8.04716C12.9554 8.14187 13.3928 8.37565 13.7361 8.71892C14.0793 9.0622 14.3131 9.49955 14.4078 9.97569C14.5025 10.4518 14.4539 10.9453 14.2681 11.3939C14.0824 11.8424 13.7678 12.2257 13.3641 12.4954C12.9605 12.7651 12.4859 12.9091 12.0004 12.9091V13.7273",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0008,
    cy: 16.1818,
    r: 0.818182,
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.5327d8ae.svg";
export { ForwardRef as ReactComponent };